export default __webpack_public_path__ + "static/media/favicon 6.a093d790.ico";